import Bugsnag from "@bugsnag/js";
import { onValue, ref } from "firebase/database";
import axiosInstance from "../../axiosInstance";
import { FIREDB } from "../../firebaseInstance";

import URL from "../../urls";
import { logout } from "./authActions";
import {
  CHATLIST_LOADING,
  CLEAR_NEW_CHAT_UNREAD_ROOM_IDS,
  FETCH_CHAT_LIST,
  REMOVE_NEW_CHAT_UNREAD_ROOM_ID,
  SAVE_DECRYPTION_KEY,
  SET_NEW_CHAT_UNREAD_ROOM_IDS,
  SET_MOBILE_UNREAD_CHAT_COUNT,
  TOGGLE_CHAT_BLOCK,
  UPSERT_NEW_CHAT_UNREAD_ROOM_ID,
} from "./types";

export const getChatList = firebaseid => async dispatch => {
  dispatch({ type: CHATLIST_LOADING, payload: true });
  const dbRef = ref(FIREDB, "user_friend_map/" + firebaseid);
  onValue(
    dbRef,
    snapshot => {
      let chatList = [];
      let usersList = snapshot.val();

      if (!usersList) {
        dispatch({ type: CHATLIST_LOADING, payload: false });
        return;
      }

      Object.keys(usersList).forEach(item => {
        chatList.push({
          client: {
            ...usersList[item],
            unreadCount: usersList[item].unread_messages
              ? Object.keys(usersList[item].unread_messages).length
              : 0,
          },
          id: item,
        });
      });

      const chatsUnread = chatList
        .filter(chat => chat.client.unreadCount > 0)
        .sort((a, b) => b.client.lastmodified - a.client.lastmodified);
      const chatsRead = chatList
        .filter(chat => chat.client.unreadCount === 0)
        .sort((a, b) => b.client.lastmodified - a.client.lastmodified);

      chatList = [...chatsUnread, ...chatsRead];

      dispatch({
        type: SET_MOBILE_UNREAD_CHAT_COUNT,
        payload: chatsUnread.length,
      });
      dispatch({ type: FETCH_CHAT_LIST, payload: chatList });
      dispatch({ type: CHATLIST_LOADING, payload: false });
    },
    err => {
      console.log({ err });
      Bugsnag.notify(err);
      if (err?.code === "storage/unauthorized") {
        dispatch(logout());
      }
    }
  );
};

export const saveDecryptionKey = (chatChannel, key) => {
  return { type: SAVE_DECRYPTION_KEY, payload: { chatChannel, key } };
};

const normalizeRoomIds = roomIds =>
  [...new Set(roomIds.map(roomId => Number(roomId)).filter(Boolean))];

export const setNewChatUnreadRoomIds = roomIds => ({
  type: SET_NEW_CHAT_UNREAD_ROOM_IDS,
  payload: normalizeRoomIds(roomIds),
});

export const upsertNewChatUnreadRoomId = roomId => ({
  type: UPSERT_NEW_CHAT_UNREAD_ROOM_ID,
  payload: Number(roomId),
});

export const removeNewChatUnreadRoomId = roomId => ({
  type: REMOVE_NEW_CHAT_UNREAD_ROOM_ID,
  payload: Number(roomId),
});

export const clearNewChatUnreadRoomIds = () => ({
  type: CLEAR_NEW_CHAT_UNREAD_ROOM_IDS,
});

export const fetchUnreadChatRoomIds = () => async dispatch => {
  try {
    const response = await axiosInstance.get(URL.unreadChatRoomIds);
    const roomIds = response?.data?.data?.chat_room_ids || [];

    dispatch(setNewChatUnreadRoomIds(roomIds));
  } catch (error) {
    Bugsnag.notify(error);
  }
};

export const toggleChatBlock = () => {
  return { type: TOGGLE_CHAT_BLOCK };
};

export const logMessageSent = async clientId => {
  try {
    await axiosInstance.put(URL.logMessageSent, { customer_id: clientId });
  } catch (error) {
    Bugsnag.notify(error);
  }
};
